// Front/src/App.js

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import MainPage from './pages/Main';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import NewReport from './pages/NewReport';
import NewScale from './pages/NewScale';
import NewClient from './pages/NewClient';
import NewScaleType from './pages/NewScaleType';
import MyTasks from './pages/MyTasks';
import SearchServiceCall from './pages/SearchServiceCall';
import { LanguageProvider } from './context/LanguageContext';
import { HelmetProvider } from 'react-helmet-async';  // Import HelmetProvider
import React, { useState, useEffect } from 'react';  // Import useState and useEffect
import './style/App.css'; // loading all css here avoids style rendering bugs
import 'bootstrap/dist/css/bootstrap.min.css';
import './style/LoginandSignup.css';
import './style/Main.css';
import './style/MyTasks.css';
import './style/NavBar.css';
import './style/NewClient.css';
import './style/NewReport.css';
import './style/NewScale.css';

function App() {

  // Define dark mode state
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem("darkMode") === "enabled";
  });

  // ✅ Apply dark mode to the document when the state changes
  useEffect(() => {
    document.body.classList.toggle("dark-mode", darkMode);
    document.documentElement.setAttribute("data-theme", darkMode ? "dark" : "light");
    localStorage.setItem("darkMode", darkMode ? "enabled" : "disabled");
  }, [darkMode]);

  return (
    <HelmetProvider> {/* ✅ Wrap the whole app inside HelmetProvider */}
      <LanguageProvider> {/* 🌍 Wrap everything in the Language Context */}
        <div className={`App ${darkMode ? "dark-mode" : ""}`} data-theme={darkMode ? "dark" : "light"}>
          <BrowserRouter>
            <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />
            <div className="pages">
              <Routes>
                  <Route path="/" element={<Login />} />
                  
                  <Route
                    path="/main"
                    element={
                      <ProtectedRoute>
                        <MainPage />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/newreport"
                    element={
                      <ProtectedRoute>
                        <NewReport />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/newscale"
                    element={
                      <ProtectedRoute>
                        <NewScale />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/newscaletype"
                    element={
                      <ProtectedRoute>
                        < NewScaleType />
                      </ProtectedRoute>
                    }
                  />


                  <Route
                    path="/newclient"
                    element={
                      <ProtectedRoute>
                        <NewClient />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/mytasks"
                    element={
                      <ProtectedRoute>
                        <MyTasks />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/searchservicecall"
                    element={
                      <ProtectedRoute>
                        <SearchServiceCall />
                      </ProtectedRoute>
                    }
                  />

                </Routes>
              </div>
            </BrowserRouter>
          </div>
        </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
